/** Exclusion changes this attendance only, and keeps the line listed so Restore can undo it. */
import { PlannedItemCommandId, PlannedItemLine } from '@jms/model';
import { Command } from '@workbuddy/ui/model';
import { plannedItemRowAction } from './planned.item.command.support';

export const plannedItemExcludeRowCommand = (line: PlannedItemLine, onSaved?: () => void): Command => plannedItemRowAction(PlannedItemCommandId.Exclude, line, onSaved);
